'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Name = function (_React$Component) {
    _inherits(Name, _React$Component);

    function Name(props) {
        _classCallCheck(this, Name);

        var _this = _possibleConstructorReturn(this, (Name.__proto__ || Object.getPrototypeOf(Name)).call(this, props));

        _this.handleReturn = function (code, value) {
            _this.props.doSetReturn({ componentCode: _this.props.component.code, code: code, value: value });
        };

        _this.state = {
            validateGender: false,
            validateFirstName: false,
            validateLastName: false
        };
        return _this;
    }

    _createClass(Name, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !(0, _fastDeepEqual2.default)(this.props, nextProps) || !(0, _fastDeepEqual2.default)(this.state, nextState);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var addGender = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'AddGender') === 'no' ? false : true;
            var genderError = false;
            // Only validate gender when gender is added
            if (addGender) {
                genderError = this.state.validateGender === true && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validGender');
            }
            var firstNameError = this.state.validateFirstName === true && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validFirstName');
            var lastNameError = this.state.validateLastName === true && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validLastName');

            return _react2.default.createElement(
                _metrixCommon.Grid,
                null,
                _react2.default.createElement(
                    _metrixCommon.Row,
                    { nogutter: true },
                    addGender && _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 4, md: 2, nogutterleft: true },
                        _react2.default.createElement(_metrixCommon.DropDown, {
                            key: this.props.component.code + '_Gender',
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Gender' }),
                            value: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Gender') && { code: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Gender') },
                            references: [{ code: 'female', value: 'F' }, { code: 'male', value: 'M' }],
                            referencesEvent: function referencesEvent() {},
                            changeEvent: function changeEvent(value) {
                                return _this2.handleReturn('Gender', value.code);
                            },
                            top: _metrixCommon.Sizes.sm,
                            onBlur: function onBlur() {
                                return _this2.setState({ validateGender: true });
                            },
                            error: genderError
                        })
                    ),
                    _react2.default.createElement(_metrixCommon.Column, { xs: 9, sm: 0, nogutter: true }),
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 12, md: addGender ? 10 : 6, nogutter: this.props.mobile, nogutterright: addGender, nogutterleft: !addGender },
                        _react2.default.createElement(_metrixCommon.Input, {
                            key: this.props.component.code + '_FirstName',
                            value: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'FirstName'),
                            changeEvent: function changeEvent(value) {
                                return _this2.handleReturn('FirstName', value);
                            },
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FirstName' }),
                            top: _metrixCommon.Sizes.sm,
                            onBlur: function onBlur() {
                                return _this2.setState({ validateFirstName: true });
                            },
                            error: firstNameError
                        })
                    ),
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 12, md: addGender ? 12 : 6, nogutter: this.props.mobile, nogutterleft: addGender, nogutterright: true },
                        _react2.default.createElement(_metrixCommon.Input, {
                            key: this.props.component.code + '_LastName',
                            value: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'LastName'),
                            changeEvent: function changeEvent(value) {
                                return _this2.handleReturn('LastName', value);
                            },
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'LastName' }),
                            top: _metrixCommon.Sizes.sm,
                            onBlur: function onBlur() {
                                return _this2.setState({ validateLastName: true });
                            },
                            error: lastNameError
                        })
                    )
                )
            );
        }
    }]);

    return Name;
}(_react2.default.Component);

exports.default = Name;